import React from "react";
import cx from "classnames";
import { CrossThickIcon, ExpandIcon, FullScreenIcon } from "assets";
import ProfileButton from "pages/Profile/components/common/ProfileButton";

interface Props {
  isExpanded?: boolean;
  toggleClick: () => void;
  fullScreenClick: () => void;
  className?: string;
}

const SectionControl = ({
  isExpanded,
  toggleClick,
  fullScreenClick,
  className,
}: Props) => {
  return (
    <div
      className={cx(
        "absolute right-3 top-3 z-[1] flex gap-2 dark:text-white",
        className
      )}
    >
      <ProfileButton
        className={cx("rounded-full", {
          "lg:hidden": !isExpanded,
        })}
        onClick={fullScreenClick}
      >
        <FullScreenIcon className="text-white drop-shadow-profile" />
      </ProfileButton>

      <ProfileButton
        className="hidden rounded-full lg:flex"
        onClick={toggleClick}
      >
        {isExpanded ? (
          <CrossThickIcon className="text-white drop-shadow-profile" />
        ) : (
          <ExpandIcon className="text-white drop-shadow-profile" />
        )}
      </ProfileButton>
    </div>
  );
};

export default SectionControl;
